import React from "react";
import {
  REVENUE_DONUT_CHART_SIZE,
  REVENUE_DONUT_EMPTY_RING_COLOR,
  REVENUE_DONUT_INNER_RADIUS,
  REVENUE_DONUT_OUTER_RADIUS,
} from "../revenue/constants";

type AnalyticsEmptyDonutRingProps = {
  size?: number;
  innerRadius?: number;
  outerRadius?: number;
  className?: string;
};

export const AnalyticsEmptyDonutRing: React.FC<
  AnalyticsEmptyDonutRingProps
> = ({
  size = REVENUE_DONUT_CHART_SIZE,
  innerRadius = REVENUE_DONUT_INNER_RADIUS,
  outerRadius = REVENUE_DONUT_OUTER_RADIUS,
  className,
}) => {
  const center = size / 2;
  const radius = (innerRadius + outerRadius) / 2;
  const strokeWidth = outerRadius - innerRadius;

  return (
    <svg
      aria-hidden
      viewBox={`0 0 ${size} ${size}`}
      className={className ?? "size-full"}
    >
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={REVENUE_DONUT_EMPTY_RING_COLOR}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
